import { focusableSelectors } from '../utils/variables.js';

export default {
    skipLinks: document.querySelectorAll('.skip-link'),
    init() {
        if (!this.skipLinks.length) return;

        this.skipLinks.forEach((link) => {
            link.addEventListener('click', this.handleClick.bind(this));
        });
    },
    handleClick(e) {
        e.preventDefault();

        const targetElement = document.querySelector(e.currentTarget.getAttribute('href'));
        const elementToFocus = targetElement?.querySelector(focusableSelectors);

        if (!elementToFocus) return;

        elementToFocus.focus({ focusVisible: true });
    },
};
